export default __webpack_public_path__ + "static/media/correct.b34adb55.svg";